import { Children, cloneElement } from 'react';

import { cn } from '@kit/ui/utils';

interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  direction?: 'vertical' | 'horizontal';
  [key: string]: any;
}

const Marquee = ({
  className,
  reverse,
  pauseOnHover = false,
  children,
  direction = 'horizontal',
  ...props
}: MarqueeProps) => {
  return (
    <div
      {...props}
      className={cn(
        'flex overflow-hidden [--duration:40s] [--gap:1rem]',
        direction === 'horizontal' ? 'w-full' : 'h-full',
        className,
      )}
    >
      <div
        className={cn(
          'flex gap-[--gap]',
          direction === 'horizontal'
            ? 'w-max animate-marquee'
            : 'h-max animate-marquee-vertical flex-col',
          {
            '[animation-direction:reverse]': reverse,
            'hover:[animation-play-state:paused]': pauseOnHover,
          },
        )}
      >
        {Children.map(children, (child) => cloneElement(child as any))}
        {Children.map(children, (child) => cloneElement(child as any))}
        {Children.map(children, (child) => cloneElement(child as any))}
      </div>
    </div>
  );
};

export default Marquee;
